<div
    #questionSelector
    class="cb-margin cb-margin-left-2x cb-margin-right-2x flex-row flex"
    [ngClass]="{ 'cb-disabled-card': !genericQuestion.isActive }"
>
    <div class="center-start flex-col flex">
        <span class="start-center flex-row">
            <span class="mat-body-strong">
                #{{ genericQuestion.questionNumber }}&nbsp; Question to
                {{ genericQuestion.assignedToUserName }}&nbsp;
            </span>
            <cb-user-date-time-new
                textClass="mat-body-strong"
                label="from"
                [date]="genericQuestion.createdDate"
                [userFullName]="genericQuestion.createdByName"
            ></cb-user-date-time-new>
        </span>
        <cb-display-value-new
            class="cb-margin"
            [value]="genericQuestion.request"
        ></cb-display-value-new>
        <br />
        @if (genericQuestion.isAwaitingResponse && genericQuestion.isActive) {
            <span class="mat-body-strong">Waiting for Response...</span>
        }
        @if (!genericQuestion.isAwaitingResponse) {
            <div class="flex-col">
                <cb-user-date-time-new
                    textClass="mat-body-strong"
                    label="Response from"
                    [date]="genericQuestion.responseDate"
                    [userFullName]="genericQuestion.assignedToUserName"
                ></cb-user-date-time-new>
                <cb-display-value-new
                    class="cb-margin"
                    [value]="genericQuestion.response"
                ></cb-display-value-new>
            </div>
        }
        @if (!genericQuestion.isActive) {
            <cb-user-date-time-new
                textClass="mat-body-strong"
                label="Cancelled by"
                [date]="genericQuestion.updatedDate"
                [userFullName]="genericQuestion.updatedByName"
            ></cb-user-date-time-new>
        }
    </div>
    @if (genericQuestion.isActive) {
        <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            [disabled]="
                !edit ||
                (!genericQuestion.canView &&
                    !genericQuestion.canEdit &&
                    !genericQuestion.canRespond &&
                    !genericQuestion.canCancel)
            "
        >
            <mat-icon>more_horiz</mat-icon>
        </button>
    }
    <mat-menu #menu="matMenu">
        @if (genericQuestion.canView) {
            <button mat-menu-item (click)="viewQuestion()">
                <mat-icon>pageview</mat-icon>
                View
            </button>
        }
        <button mat-menu-item (click)="editQuestion()" [disabled]="!genericQuestion.canEdit">
            <mat-icon>edit</mat-icon>
            Edit
        </button>
        <button mat-menu-item (click)="respondQuestion()" [disabled]="!genericQuestion.canRespond">
            <mat-icon>reply</mat-icon>
            Respond
        </button>
        <button mat-menu-item (click)="cancelQuestion()" [disabled]="!genericQuestion.canCancel">
            <mat-icon>cancel</mat-icon>
            Cancel Question
        </button>
    </mat-menu>
</div>
<mat-divider></mat-divider>
